import React from 'react';
import { T, fontBody, nodeColor } from '../tokens';
import { NODE_LIBRARY, getLibraryItemById } from '../constants';
import { buildLibraryDragPayload, setDragPayload } from '../utils/flowUtils';

function FlowStepLibraryItem({ item, onTriggerSelect, selectedTriggerId, disabled }) {
  const Icon = item.icon;
  const { bg, fg } = nodeColor(item.kind);
  const isSelectedTrigger = item.kind === 'trigger' && selectedTriggerId === item.id;

  const handleDragStart = (e) => {
    if (disabled) { e.preventDefault(); return; }
    e.stopPropagation();
    setDragPayload(e, buildLibraryDragPayload(item));
  };

  const handleClick = () => {
    if (disabled) return;
    if (item.kind === 'trigger') {
      onTriggerSelect(item);
    }
  };

  return (
    <div
      draggable={!disabled}
      onDragStart={handleDragStart}
      onClick={handleClick}
      title={
        disabled
          ? 'Only available for keyword-based custom automations'
          : (item.kind === 'trigger' ? 'Click or drag to set as first step' : 'Drag into the flow')
      }
      style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '7px 9px', borderRadius: 8,
        border: `1px solid ${isSelectedTrigger ? T.blue : T.lineSoft}`,
        background: isSelectedTrigger ? T.blueSoft : 'transparent',
        cursor: disabled ? 'not-allowed' : (item.kind === 'trigger' ? 'pointer' : 'grab'),
        opacity: disabled ? 0.38 : 1,
      }}
    >
      <div style={{
        width: 22, height: 22, borderRadius: 6, background: disabled ? T.lineSoft : bg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <Icon sx={{ fontSize: 11, color: disabled ? T.slateLight : fg }} />
      </div>
      <span style={{ fontFamily: fontBody, fontSize: 12, color: disabled ? T.slateLight : T.ink, fontWeight: 500 }}>{item.label}</span>
    </div>
  );
}

export default function FlowStepLibrary({ selectedTriggerId, onTriggerSelect }) {
  return (
    <div className="sma-scroll" style={{ borderRight: `1px solid ${T.line}`, background: T.card, overflowY: 'auto', padding: '16px 14px' }}>
      <div style={{
        fontFamily: fontBody, fontSize: 11, fontWeight: 700, color: T.slateLight,
        textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10,
      }}
      >
        Add to flow
      </div>
      <div style={{ fontFamily: fontBody, fontSize: 11, color: T.slateLight, marginBottom: 12 }}>
        Click a trigger to set the start step, or drag any step into the sequence.
      </div>
      {NODE_LIBRARY.map((group) => (
        <div key={group.group} style={{ marginBottom: 16 }}>
          <div style={{ fontFamily: fontBody, fontSize: 11.5, fontWeight: 600, color: T.slate, marginBottom: 8 }}>{group.group}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {group.items.map((item) => (
              <FlowStepLibraryItem
                key={item.id}
                item={item}
                onTriggerSelect={onTriggerSelect}
                selectedTriggerId={selectedTriggerId}
                disabled={false}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
